/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = MaterialRequestItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class MaterialRequestItemsEditor extends _Ext.ItemGridEditor<MaterialRequestItemsRow> {
        protected getColumnsKey() { return "Inventory.MaterialRequestItems"; }
        protected getDialogType() { return MaterialRequestItemsDialog; }
        protected getLocalTextPrefix() { return MaterialRequestItemsRow.localTextPrefix; }

        protected form: MaterialRequestItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;

        //validate pieces and weight on new creation
        public pieces = [];
        public weight = [];
        public itemids = [];
        public isUpdate: number;
        public canUpdate: number;
        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MaterialRequestDialog).CalculateAmountandTax(this.view.getItems());
                }
            })
        }
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();
            Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                //this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                this.getItem(text);

                //TODO: Add method to get item from stock 
                //this.view.setItems(this.view.getItems(), true);
            });

        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;
 
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        //}

                    });
                    (this.parentDialog as MaterialRequestDialog).CalculateAmountandTax(this.view.getItems());
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }

                    }
                    (this.parentDialog as MaterialRequestDialog).CalculateAmountandTax(this.view.getItems());

                    this.view.refresh();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            let oldvalues = [];


            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                var oldpieces = 0;
                if (this.isUpdate == 0) {
                    for (var i = 0; i < this.itemids.length; i++) {
                        if (this.itemids[i] == item.TransItemId) {
                            oldpieces = this.pieces[i];
                        }
                    }
                } else if (this.isUpdate == 1) {
                    oldpieces = oldvalues[0];
                }
                if (value > oldpieces) {
                    Q.alert('Invalid Pieces value');
                    item[field] = oldpieces;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                var oldweight = 0.0;
                if (this.isUpdate == 0) {
                    for (var i = 0; i < this.itemids.length; i++) {
                        if (this.itemids[i] == item.TransItemId) {
                            oldweight = this.weight[i];
                        }
                    }
                } else if (this.isUpdate == 1) {
                    oldweight = oldvalues[1];
                }
                if (value > oldweight) {
                    Q.alert('Invalid Weight value');
                    item[field] = oldweight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }


                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }
            (this.parentDialog as MaterialRequestDialog).CalculateAmountandTax(this.view.getItems());

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion
        setMasterValues() {
            this.RateListId = (this.parentDialog as MaterialRequestDialog).RateListId;
            this.LaborListId = (this.parentDialog as MaterialRequestDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as MaterialRequestDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as MaterialRequestDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as MaterialRequestDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as MaterialRequestDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as MaterialRequestDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as MaterialRequestDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as MaterialRequestDialog).form.PartyId.value);
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {
                    this.setMasterValues();
                    //OMS.ProductSelectGrid.ItemType = 1;
                    var grid = Common.ProductSelectGrid;
                    var filters: _Ext.SelectGridFilters = {

                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = [];
                        var rateListId = this.RateListId;
                        var newLineNo = 0;
                        var deptId = 0;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: OMS.ProductMasterRow) {
                            var PrdId = value.ProductId;
                            var bomdetails = [];
                            Purchase.PurchaseMasterService.GetLineNo({}, response => newLineNo = response.Line_No, {
                                async: false
                            });
                            var CalcOn = value.CalcOnId;
                            var Rate = 0;
                            var LaborRate = 0;
                            var Weight = value.Weight == undefined ? 1 : value.Weight;
                            var userDetails = Q.Authorization.userDefinition;

                            // **** Rate for RM **** 
                            try {
                                switch (value.ItemTypeId) {
                                    case 104:
                                        // TODO: Add Currency, Date, Rate Type
                                        Rate = Q.first(OMS.MetalRateMasterRow.getLookup().items, x => x.MetalTypeId == value.ProductTypeId && x.RateTypeId == 33
                                            && x.CompanyId == userDetails.CompanyId).Rate;
                                        break;
                                    case 105:
                                        Rate = RateHelper.GetStonePurchaseRate(value.AttributeId, rateListId, value.ProductId, value.CostMethodId);
                                        break;
                                }
                            }
                            catch (undefined) {
                                Q.notifyWarning("Rate not defined for " + value.ProductCode);
                            }
                            var VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == 13);
                            switch (value.ItemTypeId) {
                                case 101:
                                    deptId = VoucherDetails.DefaultJewelleryDepartment;
                                    break;
                                case 104:
                                    deptId = VoucherDetails.DefaultMetalDepartment;
                                    break;
                                case 105:
                                    deptId = VoucherDetails.DefaultStoneDepartment;
                                    break;
                            }


                            // #endregion

                            var purity = 0;
                            var pureweight = 0;
                            if (value.HasBom) {
                                value.BOMDetails.forEach(function (bomvalue) {
                                    //Get Product Details 
                                    var BOMRate = 0;
                                    if (value.ItemType == "METAL") {
                                        var karat = bomvalue.KaratId;
                                        var MetalColor = bomvalue.MetalColorId;
                                        var StdPurity = bomvalue.Purity;
                                        var ItemTypeId = bomvalue.ItemTypeId;

                                        // *** Rate Calculation ***
                                        //Get Rate from Metal Rate Master Calculate BOM Amount and add it to Item Rate
                                        //TODO: Add From Date to Date
                                        BOMRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == bomvalue.ProductTypeId && x.RateTypeId == 33
                                            && x.CompanyId == userDetails.CompanyId)[0].Rate;

                                        var Amount = value.CalcOnId == 3 ? value.Pieces * BOMRate : value.Weight * StdPurity * BOMRate;
                                        Rate += Amount;
                                        // *** End Rate Calculation ***

                                        var BOM: MaterialRequestBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: bomvalue.ProductCode,
                                            BOMProductId: bomvalue.BOMProductId,
                                            BOMAttributeId: bomvalue.BOMAttributeId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: value.Remarks,
                                            CalcOnId: value.CalcOnId,
                                            Pieces: value.Pieces,
                                            Weight: value.Weight,
                                            ItemTypeId: bomvalue.ItemTypeId,
                                            ItemType: bomvalue.ItemType,
                                            KaratId: bomvalue.KaratId,
                                            MetalColorId: bomvalue.MetalColorId,
                                            Purity: bomvalue.Purity,
                                            Attribute: bomvalue.Attribute,
                                            CertificateNo: bomvalue.CertificateNo
                                        }
                                        bomdetails.push(BOM);
                                    }
                                    else if (value.ItemType == "STONE") {
                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate

                                        BOMRate = RateHelper.GetStonePurchaseRate(bomvalue.BOMAttributeId, rateListId, bomvalue.BOMProductId, bomvalue.CostMethodId);
                                        var Amount = value.CalcOnId == 3 ? value.Pieces * BOMRate : value.Weight * BOMRate;
                                        Rate += Amount;


                                        var BOM: MaterialRequestBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: bomvalue.ProductCode,
                                            BOMProductId: bomvalue.BOMProductId,
                                            BOMAttributeId: bomvalue.BOMAttributeId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: bomvalue.Remarks,
                                            CalcOnId: bomvalue.CalcOnId,
                                            Pieces: bomvalue.Pieces,
                                            Weight: bomvalue.Weight,
                                            ItemType: bomvalue.ItemType,
                                            ItemTypeId: bomvalue.ItemTypeId,
                                            ShapeId: bomvalue.ShapeId,
                                            StoneColorId: bomvalue.StoneColorId,
                                            QualityId: bomvalue.QualityId,
                                            Attribute: bomvalue.Attribute,
                                            CertificateNo: bomvalue.CertificateNo
                                        }
                                        bomdetails.push(BOM);
                                    }
                                });
                            } else {
                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }
                            if (!value.HasBom) {
                                Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                                var MRate = OMS.MetalRateMasterRow.getLookup().items.filter(x => x.MetalTypeId == value.MetalId && x.RateTypeId == 33
                                    && x.CompanyId == userDetails.CompanyId && Q.formatDate(x.FromDate, "dd/MM/yyyy") == Q.formatDate(self.TransDate, "dd/MM/yyyy"));
                                Rate = MRate[0].Rate;
                                var KaratId = Q.toId(value.KaratId);
                                var puritydetails: OMS.AttributeMasterRow;
                                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                    puritydetails = response.Entity
                                }, { async: false });
                                var std = puritydetails.StdPurity;
                                purity = std;
                            }

                            //    // #endregion
                            //}

                            var purchase: MaterialRequestItemsRow = {
                                ProductId: PrdId,
                                AttributeId: value.AttributeId,
                                Line_No: newLineNo,
                                PartyId: self.PartyId,
                                SKU: value.SKU,
                                DepartmentId: deptId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                TaxCode: value.TaxCode,
                                NetAmount: value.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                GrossAmount: value.HasBom ? (Rate + LaborRate) * 1 : (Rate * Weight) * purity,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                // LaborDetails: labordetail,
                                CompanyId: companyId,

                                HSN: value.HSN,
                                InStock: false,
                                IsClosed: false,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom,
                                StockAllocation: false
                            };
                            orddetails.push(purchase);

                        });
                        for (let MaterialRequestDetail of orddetails) {
                            MaterialRequestDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = MaterialRequestDetail;
                            this.view.addItem(MaterialRequestDetail);
                        }
                        //new MaterialRequestDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();
                }
            });



            return buttons;
        }



        // #endregion




        //validateEntity(row: MaterialRequestItemsRow, id: number) {
        //    if (!super.validateEntity(row, id))
        //        return false;                                   

        //    row.ProductCode = OMS.ProductMasterRow.getLookup().itemById[row.ProductId].ProductCode;
        //    return true;
        //}    

        /*
                validateEntity(row, id) {
                    row.P = Q.toId(row.ProductID);
        
                    var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PrdId === row.ProductID);
                    if (sameProduct && this.id(sameProduct) !== id) {
                        Q.alert('This product is already in MaterialRequest details!');
                        return false;
                    }
        
                    return true;
                }*/
    }
}